/**
 * Animation utility functions for components
 * These functions return Tailwind CSS classes for animations
 * with optional delay parameters
 */

/**
 * Creates a slide-up animation with optional delay
 * @param delay Optional delay in milliseconds
 * @returns Tailwind CSS classes for animation
 */
export const slideUp = (delay = 0) => {
  return `animate-fade-in-up ${getDelayClass(delay)}`;
};

/**
 * Creates a slide-left animation with optional delay
 * @param delay Optional delay in milliseconds
 * @returns Tailwind CSS classes for animation
 */
export const slideLeft = (delay = 0) => {
  return `animate-slide-in-left ${getDelayClass(delay)}`;
};

/**
 * Creates a slide-right animation with optional delay
 * @param delay Optional delay in milliseconds
 * @returns Tailwind CSS classes for animation
 */
export const slideRight = (delay = 0) => {
  return `animate-slide-in-right ${getDelayClass(delay)}`;
};

/**
 * Creates a fade-in animation with optional delay
 * @param delay Optional delay in milliseconds
 * @returns Tailwind CSS classes for animation
 */
export const fadeIn = (delay = 0) => {
  return `animate-fade-in ${getDelayClass(delay)}`;
};

/**
 * Helper function to get the appropriate delay class
 * @param delay Delay in milliseconds
 * @returns Tailwind CSS class for animation delay
 */
const getDelayClass = (delay: number): string => {
  if (delay === 0) return '';
  if (delay <= 100) return 'delay-100';
  if (delay <= 200) return 'delay-200';
  if (delay <= 300) return 'delay-300';
  if (delay <= 400) return 'delay-400';
  if (delay <= 500) return 'delay-500';
  if (delay <= 700) return 'delay-700';
  return 'delay-1000';
}; 